import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import Divider from './../Images/divider.png';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';


import BlogImg from './../Images/blog-img.png';
import Footer from '../Components/Footer';
import { FaSearch } from "react-icons/fa";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";

const items = [{
    id: 1,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
}, {
    id: 2,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
},
{
    id: 3,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
},
{
    id: 4,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
},
{
    id: 5,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
},
{
    id: 6,
    imgSrc: BlogImg,
    category:'Investment',
    date: 'AUGust 13, 2021',
    description:'The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us realize the importance of the buying of house'
},
];
function Items({ currentItems }) {
    return (
      <>
        {currentItems &&
          currentItems.map((item) => (
            <div className="col-md-6 mb-4">
                            <div className="blog-bx p-3">
                                <div className="blog-img mb-4">
                                    <img src={item.imgSrc} alt="" />
                                </div>
                                <div className="blog-tags mb-3">
                                    <span className="invst">{item.category}</span>
                                    <span className='dte'>{item.date}</span>
                                </div>
                                <div className="blog-desc">
                                    <p>{item.description} <Link to="">Read More</Link></p>
                                </div>
                            </div>

                        </div>
          ))}
      </>
    );
  }
  function PaginatedItems({ itemsPerPage }) {

    const [itemOffset, setItemOffset] = useState(0);
  
  
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);
  
    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % items.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
  
    return (
      <>
        <Items currentItems={currentItems} />
        <ReactPaginate
          breakLabel="..."
          nextLabel={<AiOutlineRight/>}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={<AiOutlineLeft/>}
          renderOnZeroPageCount={null}
        />
      </>
    );
  }
  
  function Blog({ itemsPerPage }) {
    const [itemOffset, setItemOffset] = useState(0);

    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);
  
    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % items.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
    return (
        <>
            <Header />

            <div className="pt-150">
                <div className="container mb-5">
                    <div className="main-title-3 text-center">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Our Blog</h1>
                        <p>Get fresh, actionable tips on investment with vista</p>

                    </div>
                </div>

            </div>

            <div className="blogs mb-70">
                <div className="container">

                    <div className="d-flex justify-content-between mb-30 align-items-center">
                        <div className="filters">
                            <button className='active'>All</button>
                            <button>New</button>
                            <button>Popular</button>
                        </div>
                        <div className="Search">
                            <form action="">
                                <div className="search-blog">
                                <button><FaSearch /></button>
                                    <input placeholder='Search' type="text" />
                                    
                                </div>
                            </form>
                        </div>
                    </div>
                   
                    <div className="blogs-area row">
                    {/* <Items currentItems={currentItems} /> */}
                    <PaginatedItems itemsPerPage={4} />

                        {/* <div className="col-md-6 mb-4">
                            <div className="blog-bx p-3">
                                <div className="blog-img mb-4">
                                    <img src={BlogImg} alt="" />
                                </div>
                                <div className="blog-tags mb-3">
                                    <span className="invst">Investment</span>
                                    <span className='dte'>AUGust 13, 2021 </span>
                                </div>
                                <div className="blog-desc">
                                    <p>The Corona Virus has impacted the Lives of many people across the Globe. The Covid-19 has made us
                                        realize the importance of the buying of house <Link to="">Read More</Link></p>
                                </div>
                            </div>

                        </div>
                        
                        */}
                    </div>

                </div>

            </div>

            <Footer />
        </>
    )
}

export default Blog